<script>
export default {
    name: 'IconPencil',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-pencil"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M56 50v6H8v-6h48zM42.614 15.441l5.68 5.68L25.5 44H20v-6l22.614-22.559zM50.074 8l5.657 5.657-4.614 4.63-5.671-5.67L50.074 8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
